export enum Roles {
    User = 1,
    SuperUser = 2,
    ToolAdmin = 3,
    FullAdmin = 4,
}
